// Kampagnenseite

jQuery(document).ready(function ($) {
  $(".campaignsliderinit").flickity({
    // options
    cellAlign: "left",
    contain: true,
    fullscreen: true,
    lazyLoad: 1,
  });
});

("use strict");

var panels = document.querySelectorAll(".panel");

function toggleOpen() {
  this.classList.toggle("open");
}

function toggleActive(e) {
  if (e.propertyName.indexOf("flex")) {
    this.classList.toggle("open-active");
  }
}

// panels.forEach(function (panel) {
//   return panel.addEventListener('click', toggleOpen);
// });
// panels.forEach(function (panel) {
//   return panel.addEventListener('transitionend', toggleActive);
// });

// panels.forEach(function(panel) {
//   const background = panel.dataset.background;
//   panel.style.backgroundImage = `url('${background}')`;
// })

for (var i = 0; i < panels.length; i++) {
  panels[i].addEventListener("click", toggleOpen);
}

for (var i = 0; i < panels.length; i++) {
  panels[i].addEventListener("transitionend", toggleActive);
}

// for (var i = 0; i < panels.length; i++) {
//   var background = panels[i].dataset.background;
//   panels[i].style.backgroundImage = "url('".concat(background, "')");
// }



let observer = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      let lazyElement = entry.target;
      let actualImage = lazyElement.getAttribute('data-background');
      lazyElement.style.backgroundImage = `url(${actualImage})`;
      observer.unobserve(lazyElement);
    }
  });
});

document.querySelectorAll('.panel').forEach(element => {
  observer.observe(element);
});